var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadReactionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.28 108.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.24px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.14,18.09c19.89,0,36.06,16.17,36.06,36.05s-16.17,36.06-36.06,36.06-36.06-16.17-36.06-36.06S34.26,18.09,54.14,18.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.14,90.2c-19.88,0-36.06-16.17-36.06-36.06S34.26,18.09,54.14,18.09s36.06,16.17,36.06,36.05-16.17,36.06-36.06,36.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.64,69.32c3.02-6.66,9.73-11.31,17.5-11.31s14.48,4.65,17.5,11.31"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.4,
    y1: 43.18,
    x2: 35.15,
    y2: 47.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 73.13,
    y1: 47.64,
    x2: 62.88,
    y2: 43.18
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadReactionIcon);
export default __webpack_public_path__ + "static/media/sad-reaction-icon.3c9fa0a9772a5d53951f045796a3267f.svg";
export { ForwardRef as ReactComponent };